import { Input } from "@/components/Form/Input"
import { Title } from "@/components/Title"
import { Control, FieldValues, Path, useFormContext } from "react-hook-form"
import { FormattedMessage, useIntl } from "react-intl"

export const ExpensePinCode = <T extends FieldValues>({ control, isVertex }: { control: Control<T>; isVertex?: boolean }) => {
  const { $t: t } = useIntl()
  const { watch } = useFormContext()
  if (isVertex) return null
  return (
    <>
      <Title variant="title" className="mb-2.5">
        <FormattedMessage id="pin" />
      </Title>
      <div className="grid grid-cols-2 gap-2.5">
        <Input.Form
          control={control}
          type="password"
          name={"pin" as Path<T>}
          placeholder={t({ id: "create-pin" })}
          className="mb-2.5 col-span-2 md:col-span-1"
          autoComplete="new-password"
          required={!isVertex}
          isPinField
        />
        <Input.Form
          control={control}
          type="password"
          name={"pin_confirm" as Path<T>}
          placeholder={t({ id: "confirm-pin" })}
          className="col-span-2 md:col-span-1"
          autoComplete="new-password"
          required={!isVertex}
          isPinField
          rules={{
            validate: (value: string) => value === watch("pin") || t({ id: "pin-not-match" }),
          }}
        />
      </div>
    </>
  )
}
